export default {
    LTC: 'Litecoin',
    XRP: 'Ripple',
    ETH_USDT: 'Tether ERC20',
    ETH: 'Ethereum',
    BTC: 'Bitcoin',
    USDT: 'Tether OMNI',
    ETH_USDC: 'USD Coin',
    ETH_TRUE_USD: 'TrueUSD',
    ETH_PAX: 'Paxos Standard',
    TRX: 'Tron',
    TRX_BTT: 'BitTorrent',
    TRX_USDT: 'Tether TRС20',
    DOGE: 'Dogecoin',
    XVG: 'Verge',
    BSV: 'BitcoinSV',
    BTG: 'Bitcoin Gold',
    BCH: 'Bitcoin Cash',
    ETH_DAIM: 'Dai Stablecoin',
    ETH_DAI: 'Sai Stablecoin v1.0',
    ETH_MKR: 'Maker',
    ETH_OKB: 'OKB',
    ETH_KNC: 'KyberNetwork',
    ETH_BNT: 'Bancor',
    XMR: 'Monero',
    ETH_UAX: 'Crypto UAX',
    XLM: 'Stellar',
    BNB: 'Binance Coin',
    FIO: 'FIO',
    ETC: 'Ethereum Classic',
    ETH_ONE: 'Harmony',
    ETH_BUSD: 'Binance USD ERC20',
    ETH_LINK: 'ChainLink Token ERC20',
    ETH_SUSHI: 'Sushi Token',
    ETH_HUOBI: 'Huobi Token',
    ETH_UNI: 'Uniswap Token ERC20',
    ETH_ENJ: 'EnjinCoin',
    ETH_AAVE: 'Aave Token',
    ETH_GRT: 'Graph Token',
    ETH_CRV: 'Curve DAO Token',
    ETH_MATIC: 'Polygon',
    ETH_OMG: 'OMG Network',
    ETH_CHZ: 'Chiliz',
    ETH_BAT: 'Basic Attention Token',
    ETH_YFI: 'yearn.finance',
    ETH_ZRX: '0x',
    ETH_SNX: 'Synthetix',
    ETH_RSR: 'Reserve Rights',
    ETH_SXP: 'Swipe',
    ETH_CRO: 'Crypto.com Coin',
    ETH_BADGER: 'Badger DAO',
    ETH_BTC: 'Wrapped BTC ERC20',
    ETH_ALPHA: 'Alpha Finance Lab',
    ETH_1INCH: '1inch',
    ETH_BAL: 'Balancer',
    ETH_COMP: 'Compound',
    ETH_SHIB: 'Shiba ERC20',
    BNB_SMART: 'BNB Smart Chain',
    BNB_SMART_CAKE: 'PancakeSwap Token',
    BNB_SMART_BTC: 'BTC Binance-Peg',
    BNB_SMART_ETH: 'ETH Binance-Peg',
    BNB_SMART_USD: 'USD Binance-Peg',
    BNB_SMART_LTC: 'LTLTC Binance-PegC',
    BNB_SMART_DOGE: 'DOGE Binance-Peg',
    BNB_SMART_ADA: 'Cardano Binance-Peg',
    BNB_SMART_LINK: 'ChainLink Binance-Peg',
    BNB_SMART_UNI: 'Uniswap Binance-Peg',
    BNB_SMART_BAT: 'Basic Attention Token Binance-Peg',
    BNB_SMART_SXP: 'Swipe Token Binance-Peg',
    BNB_SMART_ALPHA: 'Alpha Finance Binance-Peg',
    TON: 'TON',
    
    UAH: 'Hryvnia',
    RUB: 'Ruble',
    USD: 'US dollar',
    EUR: 'Euro',
    GBP: 'Pound sterling',
    TRY: 'Turkish lira',
    KZT: 'Tenge',
    AUD: 'Australian Dollar',
    BGN: 'Bulgarian Lev',
    BRL: 'Brazilian Real',
    CAD: 'Canadian Dollar',
    CHF: 'Swiss Franc',
    CNY: 'Chinese Yuan',
    COP: 'Colombian Peso',
    CZK: 'Czech Koruna',
    DKK: 'Danish Krone',
    DOP: 'Dominican Peso',
    EGP: 'Egyptian Pound',
    HKD: 'Hong Kong Dollar',
    HRK: 'Croatian Kuna',
    IDR: 'Indonesian Rupiah',
    ILS: 'Israeli New Sheke',
    JOD: 'Jordanian Dinar',
    JPY: 'Japanese Yen',
    KES: 'Kenyan Shilling',
    KRW: 'South Korean Won',
    KWD: 'Kuwaiti Dinar',
    LKR: 'Sri Lankan Rupee',
    MAD: 'Moroccan Dirham',
    MXN: 'Mexican Peso',
    MYR: 'Malaysian Ringgit',
    NGN: 'Nigerian Naira',
    NOK: 'Norwegian Krone',
    NZD: 'New Zealand Dollar',
    OMR: 'Omani Rial',
    PEN: 'Peruvian Sol',
    PKR: 'Pakistani Rupee',
    PLN: 'Polish Złoty',
    RON: 'Romanian Leu',
    SEK: 'Swedish Krona',
    SGD: 'Singapore Dollar',
    THB: 'Thai Baht',
    TWD: 'Taiwan Dollar',
    VND: 'Vietnamese Dong',
    ZAR: 'South African Rand'
}